import ReducerUtilities from '../../../shared/store/reducer-utilities';
import attachmentModel from '../../models/attachment';
import attachmentCommitTypes from './commit-types';

const INITIAL_ATTACHMENT_STATE = {
  addingAttachmentFor: null,
  isEditingAttachment: null,
  isLoading: [],
  list: null,
};

function attachmentReducers(state = INITIAL_ATTACHMENT_STATE, action) {
  if (!action || !action.type) {
    return state;
  }
  switch (action.type) {
    case attachmentCommitTypes.PUSH_ATTACHMENT:
      return {
        ...state,
        list: !state.list
          ? [attachmentModel(action.attachment)]
          : [
            attachmentModel(action.attachment),
            ...state.list,
          ],
      };
    case attachmentCommitTypes.PUSH_ATTACHMENTS:
      return {
        ...state,
        list: action.attachments.map(attachment => attachmentModel(attachment)),
      };
    case attachmentCommitTypes.REMOVE_ATTACHMENT:
      return {
        ...state,
        list: [
          ...ReducerUtilities.removeModelFromList(
            action.attachmentGuid,
            state.list,
          ),
        ],
      };
    case attachmentCommitTypes.RESET_ATTACHMENT_STATE:
      return { ...INITIAL_ATTACHMENT_STATE };
    case attachmentCommitTypes.SET_ADDING_ATTACHMENT_FOR:
      return {
        ...state,
        addingAttachmentFor: action.addingAttachmentFor,
      };
    case attachmentCommitTypes.SET_ATTACHMENTS_IS_LOADING:
      return {
        ...state,
        isLoading: ReducerUtilities.updateIsLoading(
          action.isLoading,
          state.isLoading,
        ),
      };
    case attachmentCommitTypes.SET_IS_EDITING_ATTACHMENT:
      return {
        ...state,
        isEditingAttachment: action.isEditingAttachment,
      };
    default:
      return state;
  }
}

export default attachmentReducers;
